import React from "react";

import styles from "../styles/users.module.scss";

import { Button } from "../shared/components/Button";
import { Title } from "../shared/components/Title";

import { Icon } from "../shared/components/core/Icon";
import AddUser from "../shared/containers/Users/AddUser";

import ROLES from "data/Roles";
import { EnvironmentsAPI } from "../providers/EnvironmentsAPI";
import { Loading } from "../shared/components/Loading";
import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";
import { UserStorage } from "../shared/tools/UserStorage";

const ROLES_NAME = {
  ADMIN: "Administrador",
  MANAGER: "Lojista Franqueado",
  SHOPKEEPER: "Lojista Operador",
  MARKETING: "Marketing",
  SAC: "SAC",
  SUPPORT: "Suporte",
};

export default class Users extends React.Component {
  state = {
    environment: {},
    environment_id: null,
    isLoading: false,
    open: false,
    userEdit: {},
    close: false,
    users: [],
    units: [],
    selectedUserUnits: [],
    activeUser: {},
  };

  constructor(props) {
    super(props);
  }

  async setAsyncState(data) {
    return new Promise((resolve) => this.setState(data, resolve));
  }

  async componentDidMount() {
    this.setState({
      environment: EnvironmentStorage.getEnvironment(),
    });

    return this.loadCustomers();
  }

  allowAddUser() {
    const userType = UserStorage?.getUserType();
    return userType === "HOLDING" || userType === "BRAND";
  }

  async loadCustomers() {
    await this.setAsyncState({ isLoading: true, users: [], activeUser: {} });

    const user = UserStorage.getLoggedUser();
    const environment = EnvironmentStorage.getSelectedEnvironment();

    const response = await EnvironmentsAPI.getUsers(environment);
    const unitsResponse = await EnvironmentsAPI.getAvailableUnits(environment);

    let users = [];
    if (this.allowAddUser()) {
      users = response.getData([]);
    } else {
      users = response.getData([]).filter((u) => u.id === user.id);
    }

    const units = unitsResponse.getData([]);

    this.setState({
      environment_id: environment,
      users,
      units,
      activeUser: user,
      isLoading: false,
    });
  }

  async onEditUser(userId) {
    const { environment_id, units, activeUser } = this.state;
    const response = await EnvironmentsAPI.getUserByUserId(
      environment_id,
      userId
    );

    const unitsResponse = await EnvironmentsAPI.getAvailableUnitsByUser(
      environment_id,
      activeUser.user_id == userId ? "me" : userId
    );

    const selectedUnitsData = unitsResponse.getData([]);
    const userData = response.getData({});

    this.setState({
      userEdit: userData,
      selectedUserUnits: selectedUnitsData.map((u) => u.id),
      open: true,
    });
  }

  render() {
    const {
      open,
      userEdit,
      isLoading,
      activeUser,
      users,
      units,
      selectedUserUnits,
      environment,
    } = this.state;

    const getSubtitle = () => {
      if (environment?.brand)
        return `${environment.brand.name} - ${environment.name}` + (environment.active === false ? ' (Inativa)' : '');
      return environment?.name;
    };

    return (
      <div className={styles.usersContainer}>
        <Title title="Usuários" subtitle={getSubtitle()}>
          {this.allowAddUser() === true && (
            <Button
              design="primary"
              onClick={() => this.setState({ userEdit: {}, open: true })}
              add
            >
              Criar usuário
            </Button>
          )}
        </Title>

        {isLoading && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "absolute",
              minWidth: "-webkit-fill-available",
              minHeight: "-webkit-fill-available",
            }}
          >
            <Loading />
          </div>
        )}

        <div className={styles.usersGrid}>
          {activeUser?.user_id && (
            <UserItem
              active
              user={activeUser}
              onClick={(u) => this.onEditUser(u.user_id)}
            />
          )}
          {(users || []).map((user, index) => {
            return (
              user.id !== activeUser?.user_id && (
                <UserItem
                  key={index}
                  user={user}
                  onClick={(u) => this.onEditUser(u.id)}
                />
              )
            );
          })}
        </div>

        {open && (
          <AddUser
            visible={open}
            onClose={() => this.setState({ open: false, userEdit: {}, selectedUserUnits: [] })}
            user={userEdit}
            units={units}
            selectedUserUnits={selectedUserUnits}
            onSave={() => {
              this.setState({ open: false }, this.loadCustomers.bind(this));
            }}
            onDelete={() => {
              this.setState({ open: false }, this.loadCustomers.bind(this));
            }}
            environment={environment}
          />
        )}
      </div>
    );
  }
}

const UserItem = ({ user, onClick, active }) => {
  const userClassName = `${styles.user} ${(active && styles.active) || ""}`;

  return (
    <div className={styles.userCard} onClick={() => onClick && onClick(user)}>
      <div className={userClassName}>
        <div className={styles.icon}>
          <Icon name="user" size="1x" />
        </div>
        <div className="d-flex flex-column w-100">
          <div className={styles.header}>
            <p className={styles.name}>{user.name}</p>
          </div>
          <div className="d-flex align-center justify-between">
            <p className={styles.username}>{user.username}</p>
            <p className={styles.username}>{ROLES_NAME[user.role]}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
